import dayjs from 'dayjs';

import { BIAServiceCode } from '@/shared/types/serviceCodes';

import { TODAY } from '@/helpers/dates';

import { InsuranceServiceError } from '../model/types';

export const SERVICE_CODE = BIAServiceCode.INSURANCE;
export const STEP_NUMBER_TO_PAY = 7;
export const STEP_NUMBER_SIGN_UP = 6;
export const STEP_NUMBER_TO_EDIT_PHONE = 2;
export const getOneDayFromToday = (): dayjs.Dayjs =>
  dayjs(new Date(TODAY.getFullYear(), TODAY.getMonth(), TODAY.getDate() + 1));
export const getEightDaysFromToday = (): dayjs.Dayjs =>
  dayjs(new Date(TODAY.getFullYear(), TODAY.getMonth(), TODAY.getDate() + 8));
export const INSURANCE_SERVICE_ERROR_MESSAGES: Record<
  InsuranceServiceError,
  Record<'title' | 'description', string>
> = {
  [InsuranceServiceError.AUTH]: {
    title: 'Помилка авторизації',
    description: 'Будь ласка, спробуйте пізніше',
  },
  [InsuranceServiceError.INSURANCE_PRODUCTS_NO_DATA]: {
    title: 'Список пропозицій порожній',
    description: 'Будь ласка, спробуйте пізніше',
  },
  [InsuranceServiceError.SMTH_WENT_WRONG]: {
    title: 'Щось пішло не так',
    description: 'Будь ласка, спробуйте пізніше',
  },
  [InsuranceServiceError.REQUEST_FAILED]: {
    title: 'Не вдалося обробити запит',
    description: 'Будь ласка, спробуйте пізніше',
  },
  [InsuranceServiceError.FINANCIAL_INTELLIGENCE]: {
    title: 'Послуга недоступна',
    description: 'Ви знаходитесь під фінансовим моніторингом',
  },
  [InsuranceServiceError.WRONG_TAX_NUMBER]: {
    title: 'Послуга недоступна',
    description: 'Ваш РНОКПП не пройшов валідацію у страхової компанії',
  },
};
